import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'

import { RootState } from '../store'
import howIEatService from '../services/howIEatService'
import restaurantService from '../services/restaurantService'
import { HowIEatSpace } from '../types/howIEat'
import { Restaurant } from '../types/restaurant'

function getOwnerId(restaurant: Restaurant): string {
  return restaurant.owner._id
}

export function isRestaurantOwner(restaurant: Restaurant, userId: string): boolean {
  return !!userId && getOwnerId(restaurant) === userId
}

export function useNavSpaces() {
  const { user } = useSelector((state: RootState) => state.auth)
  const userId = user?._id || ''

  const { data: restaurants = [], isLoading: restaurantsLoading } = useQuery<Restaurant[]>({
    queryKey: ['restaurants'],
    queryFn: () => restaurantService.getUserRestaurants(),
    enabled: !!user,
  })

  const { data: howIEatSpace = null, isLoading: howIEatLoading } = useQuery<HowIEatSpace | null>({
    queryKey: ['how-i-eat', 'me'],
    queryFn: () => howIEatService.getMySpace(),
    enabled: !!user,
  })

  const ownedRestaurants = restaurants.filter((r: Restaurant) => isRestaurantOwner(r, userId))

  return {
    showRestaurantTab: ownedRestaurants.length > 0,
    showHowIEatTab: howIEatSpace != null,
    howIEatSpace,
    ownedRestaurants,
    isLoading: restaurantsLoading || howIEatLoading,
  }
}
